import { render, staticRenderFns } from "./AlternativeFormView.vue?vue&type=template&id=0f702ce0&scoped=true"
import script from "./AlternativeFormView.vue?vue&type=script&lang=js"
export * from "./AlternativeFormView.vue?vue&type=script&lang=js"
import style0 from "./AlternativeFormView.vue?vue&type=style&index=0&id=0f702ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f702ce0",
  null
  
)

export default component.exports